<div class="config-section">
    <div class="loading-skeleton" *ngIf="loading">
        <app-skeleton-loader *ngFor="let i of [1, 2, 3, 4]" height="48px" borderRadius="8px"></app-skeleton-loader>
    </div>

    <ng-container *ngIf="!loading">
        <div class="empty-state" *ngIf="!tags.length">
            {{ 'permit.config.tags.empty' | translate }}
        </div>

        <div class="tag-chips" *ngIf="tags.length">
            <span class="tag-chip" *ngFor="let tag of tags">
                {{ tag }}
                <button
                    type="button"
                    class="chip-remove"
                    [attr.aria-label]="'permit.config.common.delete' | translate"
                    (click)="confirmDelete(tag)"
                >
                    ×
                </button>
            </span>
        </div>
    </ng-container>
</div>
